import React, {
  useCallback,
  useEffect,
} from 'react'
import {
  string, func,
} from 'prop-types'
import DobSelector from '@active/react-ui/DobSelector'
import {
  toISO,
  format as formatDate,
} from '@active/core/datetime'
import isFunction from 'lodash/isFunction'
import noop from 'lodash/noop'

const format = 'MM/DD/YYYY'

function DobSelectorWithValueParse({
  value,
  onChange,
  registerValidate,
  ...rest
}) {
  const formatValue = value && formatDate(format)(toISO(value))

  const handleDobChange = useCallback(date => {
    onChange?.(toISO(date, format))
  }, [onChange])

  useEffect(() => {
    if (isFunction(registerValidate)) {
      registerValidate({
        required: v => (v ? '' : 'react-ui.validation.required'),
      })
    }
  }, [registerValidate])

  return (
    <DobSelector
      value={formatValue}
      onChange={handleDobChange}
      {...rest}
      format={format}
    />
  )
}

DobSelectorWithValueParse.propTypes = {
  value: string,
  onChange: func,
  registerValidate: func.isRequired,
}

DobSelectorWithValueParse.defaultProps = {
  value: '',
  onChange: noop,
}

export default DobSelectorWithValueParse
